import { render, staticRenderFns } from "./JoinChatContents.vue?vue&type=template&id=0d993bc7&scoped=true&"
import script from "./JoinChatContents.vue?vue&type=script&lang=js&"
export * from "./JoinChatContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d993bc7",
  null
  
)

export default component.exports